module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-modal"
  }, [_c('form', {
    staticClass: "form-ui column default-form-ui"
  }, [_c('div', {
    staticClass: "ctn-docs row"
  }, _vm._l((_vm.docs), function(doc, key) {
    return _c('div', {
      key: key,
      staticClass: "doc",
      on: {
        "click": function($event) {
          return _vm.select(key)
        }
      }
    }, [_c('div', {
      staticClass: "select",
      class: {
        active: _vm.isSelected(key)
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.good,
        "alt": ""
      }
    })]), _vm._v(" "), _c('tile-doc-selectable', {
      attrs: {
        "doc": doc
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "footer-certified row"
  }, [(_vm.docs.length === 0) ? _c('div', {
    staticClass: "side"
  }, [_vm._v("\n                      Aucun document justificatif enregistré\n                  ")]) : _c('router-link', {
    staticClass: "side link",
    attrs: {
      "to": {
        name: 'Documents'
      }
    }
  }, [_vm._v("\n                      Gérer les documents\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta right row"
  }, [_c('div', {
    staticClass: "btn btn-gold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), (_vm.docs.length > 0) ? _c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Envoyer")]) : _vm._e(), _vm._v(" "), (_vm.docs.length === 0) ? _c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "to": {
        name: 'Documents'
      }
    }
  }, [_vm._v("Ajouter un document")]) : _vm._e()], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-modal row"
  }, [_c('div', {
    staticClass: "title column"
  }, [_c('div', {
    staticClass: "head-modal-title"
  }, [_vm._v("\n                  Vérification d'identité\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "head-modal-emphase"
  }, [_vm._v("\n                  Sélectionnez le documents à vérifier\n              ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6afb4c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/Certification.vue
// module id = 1177
// module chunks = 0